export default "__VITE_ASSET__BAcnwMhD__"